module.exports = __webpack_public_path__ + "static/img/12.4045ccc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/cards/snip3down/12.png
// module id = qnjJ
// module chunks = 35